module.exports = __webpack_public_path__ + "img/rick.5eba5e74.png";